import { axios } from "@/libraries/axios";
import type { AuthRegisterVerifyMobileSchema } from "@/schemas";
import type { SendVerificationResponse } from "@/types";

class VerificationService {
	async verify(payload: Pick<AuthRegisterVerifyMobileSchema, "verify_code">) {
		try {
			const res = await axios.post("/api/v1/verifications/verify", payload);
			return res.data;
		} catch (error) {
			return Promise.reject(error);
		}
	}

	async send(payload: Pick<AuthRegisterVerifyMobileSchema, "phone_number">) {
		try {
			const res = await axios.post<SendVerificationResponse>(
				"/api/v1/verifications/phone_number",
				{
					user: payload,
				},
			);
			return res.data;
		} catch (error) {
			return Promise.reject(error);
		}
	}

	async resend(payload?: Pick<AuthRegisterVerifyMobileSchema, "phone_number">) {
		try {
			const res = await axios.post("/api/v1/verifications/resend", {
				...(payload ? { user: payload } : {}),
			});
			return res.data;
		} catch (error) {
			return Promise.reject(error);
		}
	}
}

export const verificationService = Object.freeze(new VerificationService());
